import { render, staticRenderFns } from "./ItemClassPopup.vue?vue&type=template&id=56d6b044&"
import script from "./ItemClassPopup.vue?vue&type=script&lang=js&"
export * from "./ItemClassPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports